import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PieChartService {

    makeOptions(chart, data) {
        const options = {
            type: 'pie',
            theme: 'light',
            titles: [{
                text: chart.title ? chart.title : '',
                empty: chart.emptyText ? chart.emptyText : '',
                color: chart.font.color ? chart.font.color : '#666666',
            }],
            fontFamily: chart.font.family ? chart.font.family : 'latolight',
            fontSize: chart.font.size ? chart.font.size : 9,
            color: chart.color ? chart.color : '#666666',
            colorField: 'color',
            colors: chart.colors ? chart.colors : [],
            alpha: chart.opacity ? chart.opacity : 1,
            dataProvider: chart.isClickable ? this.generateChartData(data) : data,
            valueField: chart.valueField,
            titleField: chart.titleField,
            pulledField: 'pulled',
            descriptionField: chart.descriptionField ? chart.descriptionField : '',
            balloonText: chart.balloonText ? chart.balloonText : '<strong>[[title]]: [[value]] ([[percents]]%)</strong>\n[[description]]',
            balloon: {
                fixedPosition: true,
                enabled: chart.showBalloon ? chart.showBalloon : !data.length ? false : true,
            },
            minRadius: chart.minRadius ? chart.minRadius : 90,
            labelsEnabled: chart.labelsEnabled,
            labelText: chart.labelText ? chart.labelText : '[[title]]: [[percents]]%',
            legend: {
                enabled: chart.legend.enabled ? chart.legend.enabled : false,
                combineLegend: chart.legend.combineLegend ? chart.legend.combineLegend : false,
                position: chart.legend.position ? chart.legend.position : 'bottom',
                align: chart.legend.align ? chart.legend.align : 'left',
                valueText: chart.legend.valueText ? chart.legend.valueText : '[[value]] ([[percents]]%)',
                valueAlign: chart.legend.valueAlign ? chart.legend.valueAlign : 'left',
                markerType: chart.legend.markerType ? chart.legend.markerType : 'square',
                switchable: false,
                marginTop: chart.legend.marginTop ? chart.legend.marginTop : 0,
                marginBottom: chart.legend.marginBottom ? chart.legend.marginBottom : 0,
                marginLeft: chart.legend.marginLeft ? chart.legend.marginLeft : 20,
                marginRight: chart.legend.marginRight ? chart.legend.marginRight : 20,
                data: chart.legend.data ? chart.legend.data : ''
            }
        };

        if (chart.isClickable) {
            options['listeners'] = this.addSliceClick(data);
        }
        return options;
    }

    addSliceClick(data) {
        return [{
            event: 'clickSlice',
            method: (event) => {
                const AmCharts = event.chart;
                let selected;
                if (event.dataItem.dataContext.id !== undefined) {
                    selected = event.dataItem.dataContext.id;
                } else {
                    selected = undefined;
                }
                AmCharts.dataProvider = this.generateChartData(data, selected);
                AmCharts.validateData();
            }
        }];
    }

    generateChartData(data, selected?) {
        const chartData = [];
        for (let i = 0; i < data.length; i++) {
            if (i === selected) {
                for (let x = 0; x < data[i].subs.length; x++) {
                    chartData.push({
                        type: data[i].subs[x].type,
                        percent: data[i].subs[x].percent,
                        sample: data[i].sample,
                        color: data[i].color,
                        pulled: true
                    });
                }
            } else {
                chartData.push({
                    type: data[i].type,
                    percent: data[i].percent,
                    sample: data[i].sample,
                    color: data[i].color,
                    id: i
                });
            }
        }
        return chartData;
    }

    handleDataProvided(AmCharts) {
        AmCharts.addInitHandler(chart => {
            if (chart.dataProvider.length === 0 || chart.dataProvider === undefined) {
                chart.balloon.enabled = false;
                chart.addLabel('50%', '50%', chart.titles[0].empty, 'middle', chart.fontSize);
            }
        }, ['pie']);
    }


}
